import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { Button, Image } from "..";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SliderChild = _ref => {
  var {
    title,
    sub_title,
    image,
    image_mobile,
    image_full_width,
    button_text,
    button_url,
    button_color,
    background_color = "default",
    text_color,
    image_position = "right",
    image_mobile_full_width
  } = _ref;
  var router = useRouter();
  var variant = process.env.NEXT_PUBLIC_VARIANT || "";
  var classes = useSliderChildClass({
    background_color,
    text_color
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx("div", {
      className: "min-h-[240px] md:min-h-[405px] mx-auto p-4 lg:p-8 max-w-screen-lg h-full flex flex-col justify-center relative z-10",
      children: /*#__PURE__*/_jsxs("div", {
        className: "top-6 relative mx-[8px] slider-child__text-container " + (image_position === "left" ? "sm:ml-[55%]" : ""),
        children: [/*#__PURE__*/_jsx("h2", {
          className: "md:text-[50px] lg:text-[70px] mb-2 mt-0 leading-none",
          children: title
        }), sub_title && /*#__PURE__*/_jsx("p", {
          className: image_position === "right" ? "sm:max-w-[55%]" : "",
          children: sub_title
        }), button_text && /*#__PURE__*/_jsx(Button, {
          type: "button",
          color: button_color,
          size: "md",
          href: "",
          onClick: () => router.push({
            pathname: button_url != null && button_url.cached_url ? button_url.cached_url.replace(variant, "") : "/"
          }, undefined, {
            scroll: false
          }),
          children: button_text
        })]
      })
    }), (image == null ? void 0 : image.filename) && /*#__PURE__*/_jsx(Image, {
      image: image,
      style: {
        objectPosition: image_position
      },
      className: clsx("hidden sm:block absolute object-cover", image_full_width ? "w-full h-full top-0" : "max-w-[40%] top-1/2  translate-y-[-50%]", image_position + "-0")
    }), (image_mobile == null ? void 0 : image_mobile.filename) && /*#__PURE__*/_jsx(Image, {
      image: image_mobile,
      style: {
        objectPosition: image_position
      },
      className: clsx("block sm:hidden absolute top-1/2  translate-y-[-50%]  object-cover", image_mobile_full_width ? "w-full h-full" : "max-w-[40%]", image_position + "-0")
    })]
  });
};
var useSliderChildClass = createMemoClass(props => {
  var backgroundColors = {
    default: "!bg-primary",
    primary: "!bg-primary",
    secondary: "!bg-secondary",
    tertiary: "!bg-tertiary",
    neutral: "!bg-neutral",
    transparent: "!bg-primary"
  };
  var textColors = {
    primary: "!text-primary",
    secondary: "!text-secondary",
    tertiary: "!text-tertiary",
    neutral: "!text-neutral",
    transparent: "!text-transparent"
  };
  var classes = clsx("slider-child w-full overflow-hidden relative", backgroundColors[props.background_color], props.text_color && textColors[props.text_color]);
  return classes;
});
//# sourceMappingURL=slider_child.js.map